export const languages = [
 ['en','English'],['es','Español'],['fr','Français'],['de','Deutsch'],['it','Italiano'],['pt','Português'],['nl','Nederlands'],['pl','Polski'],['ru','Русский'],['tr','Türkçe'],['ar','العربية'],['fa','فارسی'],['hi','हिन्दी'],['bn','বাংলা'],['zh-Hans','简体中文'],['ja','日本語'],['ko','한국어'],['id','Bahasa Indonesia'],['vi','Tiếng Việt'],
];
export function normalizeLanguage(value='') {
 if (/^zh(?:-|$)/i.test(value)) return 'zh-Hans';
 const code=value.toLowerCase().split('-')[0];
 return languages.some(([id])=>id===code)?code:'en';
}
function preferredLanguage() {
 if(typeof window==='undefined')return 'en';
 const explicit=new URLSearchParams(window.location.search).get('lang');
 let saved;try{saved=window.localStorage.getItem('gymbuddy-language');}catch{}
 return normalizeLanguage(explicit||saved||window.navigator.language);
}
export const language=preferredLanguage();
let messages={};
export function t(source, values={}) {
 return (messages[source] || source).replace(/\{(\w+)\}/g, (match,key) => Object.prototype.hasOwnProperty.call(values,key) ? String(values[key]) : match);
}
export async function loadLanguage() {
 if(language!=='en') {
  try { messages=(await import(`./locales/${language}.json`)).default; }
  catch(error) { console.error('Language could not be loaded', error); }
 }
 document.documentElement.lang=language;
 document.documentElement.dir=['ar','fa'].includes(language)?'rtl':'ltr';
 document.documentElement.dataset.language=language;
 try{window.localStorage.setItem('gymbuddy-language',language);}catch{}
}
export function changeLanguage(value) {
 const next=normalizeLanguage(value);
 try{window.localStorage.setItem('gymbuddy-language',next);}catch{}
 const url=new URL(window.location.href);url.searchParams.set('lang',next);
 window.location.assign(url.toString());
}
